import { useBasketState } from '@websrc/Basket/useBasketState'
import { CartModalItem } from '@websrc/MainTopbar/CartButton/Item/CartModalItem'
import React from 'react'

import * as SC from './CartModalItemList.style'

export const CartModalItemList = () => {
  const basketState = useBasketState()

  return (
    <SC.Wrapper>
      {basketState.items.map((item) => (
        <CartModalItem item={item} key={item.productNumber} />
      ))}
    </SC.Wrapper>
  )
}
